import { generalHelpers } from '@tweddle-se-team/common/helpers'
import { arrayHelpers } from '@tweddle-se-team/common/helpers'
import config from '@/utils/apiHelpers/configHelper'
import { configsActions } from '@/store/configs'
import { apiUrlSsr } from '@/utils/env'
import { proxyInstance } from '@/hooks/useApi'

const { fieldByKey } = arrayHelpers

const getApiURL = async store => {
  let apiUrlClient = null
  if (!generalHelpers.isServer()) {
    // Already set
    if (window.RUNTIME_CONFIG?.apiUrlClient) return window.RUNTIME_CONFIG?.apiUrlClient
    const { configs } = store.getState()
    // If the component uses getServerSideProps and reduxWrapper apiUrlClient it's in store
    // as default value coming from the server.
    if (configs?.apiUrlClient) {
      apiUrlClient = configs?.apiUrlClient
    } else {
      // If the component doesn't use getServerSideProps and reduxWrapper apiUrlClient is not set
      // So we need to call the API to get the apiUrlClient as last resort
      try {
        const { data } = await proxyInstance.get('clientApi')
        if (data?.apiUrlClient) {
          apiUrlClient = data.apiUrlClient
          store.dispatch(configsActions.SET_API_URL_CLIENT(apiUrlClient))
        }
      } catch (error) {
        // Optionally log the error, but avoid exposing sensitive info
        if (process.env.NODE_ENV !== 'production') {
          console.error('Failed to fetch clientApi:', error)
        }
        // apiUrlClient remains null
      }
    }
  } else {
    // Server side rendering, we need to use the apiUrlSsr
    return apiUrlSsr
  }
  if (apiUrlClient) window.RUNTIME_CONFIG = { apiUrlClient }
  return apiUrlClient
}

export const getConfigs = async ctx => {
  const { configs } = ctx.store.getState()
  if (!Object.keys(configs?.all || {}).length) {
    const allConfig = await config.getConfigs()
    const all = fieldByKey(allConfig, 'key', 'config')
    ctx.store.dispatch(configsActions.SET_ALL(all))
    return { ...configs, all }
  }
  return configs
}

const getCurrentVersion = async store => {
  if (!generalHelpers.isServer()) {
    const { data: version } = await proxyInstance.get('version')
    store.dispatch(configsActions.SET_VERSION(version))
  }
}

const setIFrameDomain = store => domain => {
  if (!generalHelpers.isServer() && domain) {
    store.dispatch(configsActions.SET_IFRAME_DOMAIN(domain))
  }
}

const configHelper = {
  getConfigs,
  getApiURL,
  getCurrentVersion,
  setIFrameDomain
}

export default configHelper
